import type {
  SCHEDULED_CONTINUOUS_EVENT,
  SCHEDULED_PULSE_EVENT,
  TIrrigationSchedulerStoreState,
} from 'App/irrigation-scheduler/utils/store/irrigationSchedulerStore'
import { TScheduledEventEnum } from 'App/irrigation-scheduler/utils/store/irrigationSchedulerStore'
import { getPermissionForSelectedProperty } from 'App/irrigation-scheduler/utils/store/selectors/getPermissionForSelectedProperty'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'

export const getEventActions = (
  fass: TFieldAssetStoreState,
  isss: TIrrigationSchedulerStoreState,
  event: SCHEDULED_CONTINUOUS_EVENT | SCHEDULED_PULSE_EVENT,
  eventIs3rdPartyControlled: boolean,
): {
  canEdit: boolean
  canDelete: boolean
  canStop: boolean
  isHappeningNow: boolean
  isInTheFuture: boolean
} => {
  const permissions = getPermissionForSelectedProperty(fass, isss)
  const now = Date.now()
  const isHappeningNow = event.dateFrom.isBefore(now) && event.dateTo.isAfter(now)
  const isInTheFuture = event.dateFrom.isAfter(now)
  const isDraftCreate = event.type === TScheduledEventEnum.DRAFT_CREATE
  const isDraftDelete = event.type === TScheduledEventEnum.DRAFT_DELETE
  const isStopped = event.type === TScheduledEventEnum.STOPPED
  const isScheduled = event.type === TScheduledEventEnum.SCHEDULED
  const isControlledZone = eventIs3rdPartyControlled
  const hasEditPermission = permissions.edit
  const hasPublishPermission = permissions.publish
  const isFertigation = !!('fertigationSchedules' in event && event.fertigationSchedules?.length)
  const canEditFertigationEvent = !isFertigation || permissions.editFertigation
  const isNotMarkedForDeletion = !isDraftDelete
  const isEditableEventType = isDraftCreate || isScheduled
  const isDeletableEventType = isDraftCreate || isScheduled // TODO: should stopped events be deletable?
  const canModifyControlledEvent = isDraftCreate || isStopped || !isControlledZone || isInTheFuture

  const canStop =
    hasPublishPermission && isControlledZone && isScheduled && isHappeningNow && canEditFertigationEvent

  const canEdit =
    hasEditPermission &&
    canEditFertigationEvent &&
    isNotMarkedForDeletion &&
    isEditableEventType &&
    (isDraftCreate || !isControlledZone || isInTheFuture)

  const canDelete =
    hasEditPermission &&
    canEditFertigationEvent &&
    isNotMarkedForDeletion &&
    isDeletableEventType &&
    canModifyControlledEvent

  return {
    canEdit,
    canDelete,
    canStop,
    isHappeningNow,
    isInTheFuture,
  }
}
